import React, { useEffect, useState } from "react";
import { setKey } from "../store/actions";
import { connect } from "react-redux";
import utils from "../utils/utils";
import StripeCheckout from 'react-stripe-checkout';
import keys from "../store/keys";
import paymentService from "../services/payment";
import moment from "moment";
import { swalError, swalSuccess } from "../utils/swal";
import logo from "../media/logo.svg";

function PaymentConfirm({ session, setKey, ...props }) {

	const [total, setTotal] = useState(0);
	const [disablePayment, setDisablePayment] = useState("disabled");

	useEffect(() => {
		let t = JSON.parse(localStorage.getItem(keys.cart)) || [];
		let sum = 0;
		if (t.forEach) {
			t.forEach(k => {
				let subTotal = parseFloat(k.selectedVariant.price) * parseInt(k.quantity);
				sum += subTotal;
			});
		}
		setTotal(sum);
	}, [session.counter]);

	const onPaymentSuccess = token => {

		if (!token) return;

		let cart = JSON.parse(localStorage.getItem(keys.cart));
		let deliveryAddress = JSON.parse(localStorage.getItem(keys.deliveryAddress));
		
		setKey(keys.isLoading, true);
		paymentService.create(session.token, {
			cart: cart,
			deliveryAddress: deliveryAddress,
			token: token,
			date: moment().format(),
			amount: total,
			currency: session.selectedRegion ? session.selectedRegion.currency : "EUR"
		})
			.then(result => {

				if (result.error) {
					swalError(result.error);
					setKey(keys.isLoading, false);
					return;
				}

				setKey(keys.isLoading, false);
				localStorage.setItem(keys.cart, JSON.stringify([]));
				localStorage.setItem(keys.deliveryAddress, JSON.stringify({}));
				swalSuccess("Payment done successfully!");
				setKey(keys.counter, parseInt(session.counter) + 1);
			});
	}

	return (
		<>
			<p className="cart-title">Order Summary</p>
			<div className="box">
				<div className="row">
					<div className="col">
						<table className="w-100">
							<tbody>
							<tr>
								<td>Sub Total</td>
								<td className="text-end">{utils.formatToCurrency(total, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</td>
							</tr>
							<tr>
								<td>Shipping</td>
								<td className="text-end">{utils.formatToCurrency(0, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</td>
							</tr>
							<tr>
								<td className="td-strong">Total</td>
								<td className="text-end td-strong">{utils.formatToCurrency(total, session.selectedRegion ? session.selectedRegion.currency : "EUR")}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div className="row text-center mt-20">
					<div className="col">
						{
							parseInt(total) > 0 &&
							<StripeCheckout
								name="Montells"
								description="Checkout with Stripe Payments"
								image={logo}
								amount={total * 100}
								currency={session.selectedRegion ? session.selectedRegion.currency : "EUR"}
								stripeKey={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}
								allowRememberMe={false}
								shippingAddress={false}
								billingAddress={false}
								token={onPaymentSuccess}
							>
								<button className="btn btn-secondary w-100">
									<div>
										Checkout with &nbsp;
										<i className="fa-brands fa-stripe fa-2x text-white" style={{ verticalAlign: "middle" }}></i>
									</div>
								</button>
							</StripeCheckout>
						}
					</div>
				</div>
			</div>
		</>
	);
}

const mapStateToProps = (store) => ({ session: store.session });
const mapDispatchToProps = (dispatch) => ({
	setKey: (key, value) => dispatch(setKey(key, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentConfirm);
